import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type"
import { byStops } from "./byStops"
import { byPrice } from "./byPrice"
import { byClass } from "./byClass"
import { byRangeTime } from "./byRangeTime"
import { byAirline } from "./byAirline"
import { byPoints } from "./byPoints"
import { byFlightInputIndex } from "./byFlightInputIndex"
import { isGalileoSystem } from "@/utils/flight/isGalileoSystem"
import { isGalileoVjOrJqFare } from "@/utils/flight/isGalileoVjOrJqFlight"

export const isFlightCountable = (state: FlightState, flight: TypeFlight) => {
  if (!flight?.segments?.length || !flight.inventories?.length) {
    return false
  }

  const fare = state.flightsResult.fares[flight.fareDataId]
  if (!fare) return false

  // Safety net: never show Galileo VJ/JQ duplicates (3-tab cards).
  if (isGalileoSystem(fare.system)) {
    const fareFlightIds =
      state.flightsResult.layout.mappingFareFlights[fare.index] || [flight.index]
    const fareFlights = fareFlightIds
      .map((id) => state.flightsResult.flights[id])
      .filter(Boolean)
    if (isGalileoVjOrJqFare(fare.system, fareFlights.length ? fareFlights : [flight])) {
      return false
    }
  }

  return byPoints(state, flight) && byFlightInputIndex(state, flight)
}

export const filterFlights = (state: FlightState, flight: TypeFlight) => {
  if (!isFlightCountable(state, flight)) return false

  return byStops(state, flight) && 
   byPrice(state, flight) && 
  byClass(state, flight) && 
  byRangeTime(state, flight) &&
  byAirline(state, flight, state.flightsResult.fares[flight.fareDataId])
}